export const TabsThemeMap = {
  dark: 'is-link',
  light: ''
};
